import type { FilterDropdownOption } from '@/components/FilterDropdown/FilterDropdown';
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';
import type { ReactElement } from 'react';

export interface CmcFilterDropdownProps {
  selectedValues: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
  className?: string;
}

const ICON_STYLE = { fontSize: '12px', width: '16px' } as const;

const CMC_VALUES = ['0', '1', '2', '3', '4', '5', '6+'] as const;

const CMC_OPTIONS: FilterDropdownOption[] = CMC_VALUES.map((value) => ({
  value,
  label: value,
  // Built at runtime so Tailwind never sees a literal glyph class and emits a colliding margin utility
  icon: <i className={`ms ms-cost ms-fw ms-${value.replace('+', '')}`} style={ICON_STYLE} aria-hidden="true" />,
  badgeClassName: 'bg-aether/20 text-aether',
}));

const TRIGGER_ICON = <i className="ms ms-cost ms-shadow ms-x ms-fw" style={ICON_STYLE} aria-hidden="true" />;

export default function CmcFilterDropdown({ selectedValues, onToggle, onClear, className }: CmcFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="CMC"
      triggerIcon={TRIGGER_ICON}
      ariaLabel="CMC filter"
      searchPlaceholder="Search CMC..."
      options={CMC_OPTIONS}
      selectedValues={selectedValues}
      onToggle={onToggle}
      onClear={onClear}
      className={className}
    />
  );
}
